import * as types from './actionTypes';  
import activeOfferingApi from '../api/activeOfferingApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doActiveOffering(email) {

  return {
    type: types.DO_ACTIVE_OFFERING, 
    email
  };
}

export function doActiveOfferingRes(data) {  
  return {
    type: types.DO_ACTIVE_OFFERING_RES, 
    data
  };
}

export function getActiveOffering(email) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      activeOfferingApi.doActiveOffering(email).then(data => {
        dispatch(doActiveOfferingRes(data));
        dispatch(doActiveOfferingRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}

